import { render, staticRenderFns } from "./basics.vue?vue&type=template&id=51769b2c&scoped=true&"
import script from "./basics.vue?vue&type=script&lang=js&"
export * from "./basics.vue?vue&type=script&lang=js&"
import style0 from "./basics.vue?vue&type=style&index=0&id=51769b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51769b2c",
  null
  
)

export default component.exports